export default __webpack_public_path__ + "static/media/logo-bw.78cbe74a.png";